export const isBranchSafeReview = review => !review?.metadata?.branch_mismatch;

export const canonicalPlaceLocationContext = place => {
  const location = String(place?.location || "").trim() || "ubicación no registrada";
  const maps = String(place?.maps || "").trim();
  return `Ubicación canónica: ${location}${maps ? ` | Mapa canónico: ${maps}` : ""}`;
};
